export default {
    paymentSuccess: {
        margin: "60px 0 0",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        rowGap: "35px",
    },

    paymentText: {
        fontSize: "36px",
        fontWeight: "500"
    },

    transactionDetails: {
        display: "flex",
        flexDirection: "column",
        textAlign: "center",
        rowGap: "6px",
    },

    transactionLabel: {
        fontSize: "16px"
    },

    columnGap: {
        marginTop: "30px"
    },

    redirectBtnsContainer: {
        display: "flex", 
        gap: "10px", 
        justifyContent: "center", 
        marginTop: "10px"
    },
}